export default {
    parts: [
        'container',
        'inner',
        'message'
    ],
    baseStyle: {
        message: {
            paddingTop: {base: '3px'}
        }
    }
}
